export default {
  region: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_B2rhhPQ0n',
  cognitoUserPoolWebClientId: '346m9kee4osqqlm8fhv4u2ham3',
  cognitoIdentityPoolId: 'us-east-1:e5f67a2b-2fd8-401e-8fce-ca252bf34f90',
  cognitoDomain: 'pv-mme-dynamic-ads-scz.auth.us-east-1.amazoncognito.com',
  redirectSignIn: 'https://scz.personal.dynamic-ads.video.amazon.dev/auth-callback',
  redirectSignOut: 'https://scz.personal.dynamic-ads.video.amazon.dev/',
  apiServerBaseUrl: 'https://api.scz.personal.dynamic-ads.video.amazon.dev',
  stage: 'personal',
  benderApiServerBaseUrl: 'https://api.beta.bender.dynamic-ads.video.amazon.dev',
  fryApiServerBaseUrl: 'https://api.beta.fry.dynamic-ads.video.amazon.dev',
  loggerBaseUrl: 'https://logger.scz.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  monitoringBaseUrl: 'https://monitoring.scz.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  featureFlags: 'enableReportingDashboard,enableBlocklist,enableAbTesting,enableSpotlightLal,enablePublisherConfigs,enablePublisherConfigCampaignForm',
  spotlightApiGatewayBaseUrl: 'https://beta.spotlight.video.amazon.dev',
  productsBucketName: '',
  mediaBucketName: 'leela-media-784303385218-us-east-1-personal',
  agentCoreWsUrl: 'wss://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn:aws:bedrock-agentcore:us-east-1:784303385218:runtime/leela_agent_orchestrator_personal-iY28mc9i4u/ws',
};
